import { render, staticRenderFns } from "./grid-fields-menu.vue?vue&type=template&id=846b9cdc&scoped=true&"
import script from "./grid-fields-menu.vue?vue&type=script&lang=js&"
export * from "./grid-fields-menu.vue?vue&type=script&lang=js&"
import style0 from "./grid-fields-menu.vue?vue&type=style&index=0&id=846b9cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846b9cdc",
  null
  
)

export default component.exports